module.exports = __webpack_public_path__ + "static/media/Makeup04.9da7a25c.jpeg";